import React from "react";
import useForwarder from "../../hooks/useForwarder";
const ForwarderVersionCell = ({ forwarderId }) => {
  const { data, isFetching } = useForwarder(forwarderId != null ? forwarderId : "");
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, "N/A");
  }
  if (isFetching && !data) {
    return /* @__PURE__ */ React.createElement("span", null, forwarderId);
  }
  return /* @__PURE__ */ React.createElement("span", null, (data == null ? void 0 : data.version) || "N/A");
};
export default ForwarderVersionCell;
